import { svg } from "config/svgStyles";

export const selectedValuesBar = {
  background: "grey9",
  display: "flex",
  flexDirection: "row",
  height: "40px",
};

export const selectedValues = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  overflow: "auto",
};

export const item = {
  flexGrow: 0,
  flexShrink: 0,

  borderLeft: "solid 1px",
  borderColor: "white",
  lineHeight: "40px",
  height: "40px",
  padding: "0 12px",

  fontFamily: "roboto",
  fontWeight: "light",
  fontSize: "14px",
  letterSpacing: "0.05em",

  whiteSpace: "nowrap",

  "&:first-of-type": {
    borderLeft: "none",
  },
};

export const viewYourSpecsButton = {
  ml: "auto",
  borderRadius: "0",
  flexGrow: 0,
  flexShrink: 0,
};

export const arrowButton = {
  border: "none",
  background: "grey9",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minWidth: "40px ",
  minHeight: "40px",
};

export const leftArrowButton = {
  ...arrowButton,
  borderRight: "solid 1px white",
  borderColor: "white",
};

export const rightArrowButton = {
  ...arrowButton,
  borderLeft: "solid 1px white",
  borderColor: "white",
};

export const arrowIcons = {
  ...svg("grey7"),
  zIndex: 3,
  width: "16px",
  height: "16px",
};
